<template>
  <div class="not-found">
    <b-container fluid>
      <h1 class="h4">{{ $t('error.notFound') }}</h1>
      <img class="image" src="@/assets/images/error.png" alt="" />
      <p>{{ $t('error.notFoundOrRemoved') }}</p>
      <p>
        {{ $t('error.operatingAgainOnTopPage') }}
      </p>
      <b-button class="button-black" @click="backtotop">{{ $t('error.backToTop') }}</b-button>
    </b-container>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  computed: {
    isRoot() {
      return this.$route.path === '/'
    },
  },
  methods: {
    ...mapActions({
      clearError: 'error/clearError',
    }),
    backtotop() {
      if (!this.isRoot) {
        this.$router.push({ name: 'shopMenu' })
      }
      this.clearError()
    },
  },
}
</script>
<style lang="scss" scoped>
.not-found {
  padding-top: 40px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;

  .h4 {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: bold;
  }

  .image {
    margin-top: 24px;
    height: 60px;
  }

  p {
    margin: 20px 0 0;
    font-size: 14px;
    white-space: pre-wrap;
  }

  .button-black {
    min-width: 240px;
    margin: 40px 0;
    background: #333;
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
